// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.TopTitle_wrapper__3ayBB {\n  margin-bottom: 18px;\n  border-bottom: 1px solid rgba(24, 144, 255, 0.5);\n  padding-bottom: 14px; }\n  .TopTitle_wrapper__3ayBB h2 {\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 28px;\n    color: #2c2c2c;\n    margin: 0;\n    text-transform: capitalize; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "TopTitle_wrapper__3ayBB"
};
module.exports = exports;
